﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconCategory } from "@tabler/icons-react";

export const CanalesIcon = IconCategory;
export const CanalesHelpText = "* Los canales indican una agrupación transversal utilizada para las tiendas. Un canal puede estar relacionado a varias tiendas.";

export class catCanales extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "Canales";
        this.def.columns.c_category_id.defaultValue = "Canales";
        this.Title = "Canales";
        this.HelpText = CanalesHelpText;
        this.Icon = CanalesIcon;
    }
}